import { render, staticRenderFns } from "./InsightsSection.vue?vue&type=template&id=037ea971&"
import script from "./InsightsSection.vue?vue&type=script&lang=js&"
export * from "./InsightsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports